import { FieldValues, UseFormRegister } from 'react-hook-form'
import { InputRadio, LabelRadio } from 'components/Toggle/styles'

interface IToggleProps {
  required?: boolean
  register: UseFormRegister<FieldValues>
  name: string
  itens: any[]
  defaultCheckedValue: string
  isError?: boolean
  onFocus?: () => void
}

type ToggleProps = IToggleProps

const Toggle: React.FC<ToggleProps> = ({ register, name, itens, isError, defaultCheckedValue, required, onFocus }) => {

  return (
    <fieldset
      data-testid="test-toggle-component"
    >
      {/* <legend className='sr-only'>Notification method</legend> */}
      <div className='space-y-1'>
        {itens && itens?.map((item, idx) => {
          const itemLabelFor=  `${item.id}-${item.value}`
          return (
            <div key={item.id || idx} className={`${name} flex items-center`} >
              <InputRadio
                data-testid={`radio-input-${idx}`}
                onFocus={onFocus}
                className={`${isError ? 'border border-errorText' : ''}`}
                {...register(name, { required: required })}
                id={itemLabelFor}
                type='radio'
                value={item.value}
                defaultChecked={item.value === defaultCheckedValue}
              />
              <LabelRadio htmlFor={itemLabelFor}>{item.title}</LabelRadio>
            </div>
          )
        })}
      </div>
    </fieldset >
  )
}

export { Toggle }
